
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import  NuDropdown from "components/nubox/NuDropdown"; 

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";


import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import NuListSearch from 'components/nubox/NuListSearch';


const data1 = [
  { value: 1, label: "Apple" },
  { value: 2, label: "Facebook" },
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class PassRestaDoc extends React.Component {  

  
  
  state = {
    modalInsertar: false,
    
        
    form: {
      id_doc:0,
      nueva_clave: "",
      confirmar_clave:'',
    },

    data: [],
    item_selected:{},
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    //this.modalRef = React.createRef();//create ref
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    //this.setState({data:[]});

    this.cargar_usuarios();
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  //------------------------
  limpiar=()=>{
    this.setState({form:{ 
      //id_doc: this.state.item_selected.value,
      nueva_clave: "",
      confirmar_clave:'',
    }}); /*ojo */ 
  }
   //-----------------
   cargar_usuarios = async() => {
    let param = { }
    
    await axios2.post("cbo_docente", param).then(res => {
        //if(res.data.length>0){ 
            this.setState({data: res.data})
            this.setState({item_selected: res.data[0]})
            this.setState({form:{...this.state.form, id_doc: res.data[0].value}}); /*ojo */ 
        //}
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //--------------------------
  
  //====================================================== 

  //-----------------------------------------------------------------
  onSubmitHandler= (event)=>{
    event.preventDefault();

    //this.save_confirm();
    this.save();
  }
  //-----------------------------------------------------------------
  save_confirm = () =>{
    console.log('save');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de save?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        //let idd = item.id_doc;
        //this.modalRef.current.save(idd);
        this.save();
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    //const id_paciente = this.props.store.paciente.id_paciente;

    let param = {
                ...this.state.form,
                id_u: user.id_u,
                };
    console.log(param);
    axios2.post("passw_restad_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);   
            this.limpiar();         
        }else{
            toast.error(res.data.mensaje);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //-------------------------------------
  render() {
  
    return (
      <div>
      
        { 
        
          //JSON.stringify( this.state )
        }
        <div className="content">

          <div className="row justify-content-center">
            <div className=" " style={{width: 450}}>
              
              <form onSubmit={ this.onSubmitHandler}>

                <div className="card h-100 ">
                  <div className="card-header bg_azul1">
                    <span className="card-title text-white  ">
                      Restablecer contraseña 
                    </span>
                  </div>

                  <div className="card-body bg_celeste3">


                    <table width="100%" align="center" className='tabla_basic'>
                      <tbody>
                        <tr>
                          <td width="40%" align="right">Usuario:</td>
                          <td>
                            <NuDropdown 
                              options={this.state.data}
                              name="id_doc"
                              value={this.state.form.id_doc}
                              onChange={this.handleChangeForm}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td align="right">Nueva Contraseña:</td>
                          <td>
                            <input
                              type='password'
                              className='form-control'
                              style={{ width: "160px"}}
                              name='nueva_clave'
                              value={this.state.form.nueva_clave}
                              onChange={this.handleChangeForm}  
                              autoComplete="off"
                              />
                            </td>
                        </tr>
                        <tr>
                          <td align="right">Confirme la nueva contraseña:</td>
                          <td>
                            <input
                                type='password'
                                className='form-control'
                                style={{ width: "160px"}}
                                name='confirmar_clave'
                                value={this.state.form.confirmar_clave}
                                onChange={this.handleChangeForm}  
                                autoComplete="off"
                                />
                             
                          </td>
                        </tr>

                        <tr bgcolor="cccccc" align="center">

                          <td colSpan="2"></td>
                        </tr>

                      </tbody>
                    </table>

                    <div align="center">

                      <input type="submit"value="Grabar" className="btn  btn-primary"/>
                    </div>

                  </div>

                  <div id="divres"></div>

                </div>

              </form>
            </div>
            {/*<!-- ---------------->*/}


          </div>

        
        
        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      </div>
    );
  }
}
//------------para que soporte la funcionalidad de parametros

export default withRouterJim (PassRestaDoc);